import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Login from '@/components/login'
import Dividends from '@/components/dividends/index'
import Contribution from '@/components/contribution/index'
import Withdraw from '@/components/withdraw/index'
import WithdrawalsRecord from '@/components/withdrawalsRecord/index'
import Raiders from '@/components/raiders/index'
import Suggest from '@/components/suggest/index'

Vue.use(Router)

export default new Router({
  base: 'yzh5',
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/',
      name: 'index',
      component: Index,
      redirect: '/PlanetFile',
      children: [{
        path: 'planetFile',
        name: 'PlanetFile',
        component: () => import('../component/planetsFile/index')
      }]
    }, {
      path: '/dividends',
      component: Dividends
    }, {
      path: '/contribution',
      component: Contribution
    }, {
      path: '/withdraw',
      component: Withdraw
    }, {
      path: '/withdrawalsRecord',
      component: WithdrawalsRecord
    }, {
      path: '/raiders',
      component: Raiders
    }, {
      path: '/suggest',
      component: Suggest
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js